module.exports = __webpack_public_path__ + "static/img/money.b7c629a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/money.png
// module id = X3s9
// module chunks = 1